import type {ReactAction} from '@netx/core/bootstrap';
import {faBook} from '@netx/core-icons';
import {CART_CURRENT_ACTION_LABELS} from '@netx/core-cart-current/locales';
import {type IAsset} from '../schema';
import {assetActionCategorizeAdd} from './asset-categorize-add';
import {assetActionCategorizeMove} from './asset-categorize-move';
import {assetActionCategorizeRemove} from './asset-categorize-remove';

/**
 * Categorize asset
 * @param params
 * @returns Action
 */
export const assetActionCategorize = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-categorize',
	cb: () => {},
	icon: faBook,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE;
	},
	children: [
		assetActionCategorizeAdd(asset),
		assetActionCategorizeMove(asset),
		assetActionCategorizeRemove(asset),
	],
	...params,
});

export default assetActionCategorize;
